import { Dimension } from '@frontend/common';
import { DefaultBadge } from '@frontend/components/badge';
import React from 'react';

const ID = 'dimension-badge';
export interface DimensionBadgeProps {
    dimension: Dimension;
}

export const DimensionBadge = (props: DimensionBadgeProps) => {
    return (
        <DefaultBadge
            id={ID}
            label={`H: ${props.dimension.height}, W: ${props.dimension.width}, D: ${props.dimension.depth}`}
        />
    );
};

export default DimensionBadge;
